import {StarFilled, StarOutlined} from '@ant-design/icons';

/**
 * Customer satisfaction display. The admin never produces a CSAT score —
 * this component is purely read-only.
 *
 *   • score ∈ {1..5}  → ★★★☆☆ (3/5), colored per tier
 *   • score === null  → "Unrated" (or em-dash) — never empty stars,
 *     which would be visually ambiguous with a 0/5 (impossible value)
 */
export const CSAT_TIER_COLORS = {
  high: '#16a34a', // 5    — testimonial-worthy
  good: '#0f172a', // 4    — neutral / fine
  mid: '#d97706', // 3    — borderline
  low: '#dc2626', // 1–2  — surface prominently
  null: '#94a3b8', // unrated
};

export const csatTier = score => {
  if (score === null || score === undefined) return 'null';
  if (score >= 5) return 'high';
  if (score === 4) return 'good';
  if (score === 3) return 'mid';
  return 'low';
};

export const CsatStars = ({
  score,
  size = 'sm',
  showNumeric = true,
  unratedLabel = 'Unrated',
}) => {
  const tier = csatTier(score);
  const color = CSAT_TIER_COLORS[tier];
  const isUnrated = score === null || score === undefined;
  const dim = size === 'lg' ? 18 : size === 'md' ? 14 : 12;

  if (isUnrated) {
    return (
      <span style={{color, fontSize: dim, fontWeight: 600}}>
        {unratedLabel}
      </span>
    );
  }

  const filled = Math.max(0, Math.min(5, Math.round(score)));
  const stars = [];
  for (let i = 1; i <= 5; i += 1) {
    stars.push(
      i <= filled ? (
        <StarFilled key={i} style={{color, fontSize: dim}} />
      ) : (
        <StarOutlined key={i} style={{color: '#cbd5e1', fontSize: dim}} />
      ),
    );
  }

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        lineHeight: 1,
      }}>
      <span style={{display: 'inline-flex', gap: 2}}>{stars}</span>
      {showNumeric ? (
        <span style={{color, fontWeight: 700, fontSize: Math.max(11, dim - 2)}}>
          ({filled}/5)
        </span>
      ) : null}
    </span>
  );
};
